import { pause, unpause, is_paused } from './ajax-helpers.js';

var $,
	page,
	existingEvents,
	lastPage;

function getEvents(nextPage) {
	var nextPageNum,
		nextPagePath;

	if (existingEvents.length < 1 || existingEvents.length < 1) {
		return;
	}

	if (is_paused(existingEvents) || (nextPage === true && lastPage === true)) {
		return;
	}

	pause(existingEvents);

	if (nextPage) {
		nextPageNum = page + 1;
	} else {
		nextPageNum = 1;
	}

	if (window.location.pathname.match(/\/page\/(\d+)\/?/) !== null) {
		nextPagePath = window.location.pathname.replace(/\/page\/\d+\/?/, '/page/' + nextPageNum + '/');
	} else {
		nextPagePath = window.location.pathname + 'page/' + nextPageNum + '/';
	}

	$.ajax(nextPagePath, {
		method: 'GET',
		dataType: 'html',
		success: function (pageContent) {

			var htmlDoc,
				newListing,
				newEvents,
				currentMonthEvents,
				currentMonth,
				nextPageFirstMonth;

			htmlDoc = $((new DOMParser()).parseFromString(pageContent, "text/html"));
			newListing = htmlDoc.find('[data-js="event-listing"]');
			newEvents = newListing.find('[data-js="event-month"], [data-js="event"]');

			//a bunch of stuff to ensure proper grouping by month without repeating month headings
			currentMonthEvents = existingEvents.find('[data-js="event-month"]').last().next('[data-js="event"]');
			currentMonth       = existingEvents.find('[data-js="event-month"]').last().data('month');
			nextPageFirstMonth = newEvents.filter('[data-js="event-month"]').first().data('month');

			if (currentMonth == nextPageFirstMonth) {
				newEvents = newEvents.not(newEvents.first()); //remove the event heading

				let actualEvents = newEvents.first().children(); //get the actual events markup from the events-row grouping

				newEvents = newEvents.not(newEvents.first()); //remove the events-row grouping

				currentMonthEvents.append(actualEvents); //append the actual events markup to the previous events-row grouping
			}

			if (newListing.length == 0 || newListing.data('last-page') == true) {
				lastPage = true;
			}

			if (newEvents.length > 0) {
				existingEvents.append(newEvents);
			}

			page = nextPageNum;

			unpause(existingEvents);
		},
		error: function () {
			unpause(existingEvents);
		}
	});
}

function initEventsPLP() {

	$              = jQuery;
	page           = 1;
	existingEvents = $('[data-js="event-listing"]');

	if (existingEvents.length < 1) {
		return;
	}

	lastPage       = existingEvents.data('last-page');

	$('[data-js="event-category-filter"]').on('change', function () {
		pause($('body'));
		window.location = $(this).val();
	});

	$(window).on('scroll', function () {
		var wHeight,
			wBot,
			postsHeight,
			postsBot;

		wHeight      = window.innerHeight;
		wBot         = window.scrollY + wHeight;
		postsHeight  = existingEvents.outerHeight();
		postsBot     = existingEvents.position().top + postsHeight;

		if (wBot >= postsBot) {
			getEvents(true);
		}
	});
}

export { initEventsPLP };